module.exports = __webpack_public_path__ + "static/media/Error_2.c48b77e8.jpg";